import { Grid } from '@mui/material';
import './ArtRequest.scss';
import ArtSimRequestForm from '../../components/ArtSimRequestForm/ArtSimRequestForm';
const ArtRequest: React.FC = () => {
  return (
    <Grid className="art-request-admin__container">
      <ArtSimRequestForm mode="ART" title="ART Request Form" />
    </Grid>
  );
};

export default ArtRequest;
